//Core
import React from "react"

//Styles
import "./index.css"

const CheckBox = ({ checked = true, click }) => {
  return (
    <>
      <input
        className="inp-cbx"
        id="cbx"
        type="checkbox"
        checked={checked}
        style={{ display: "none" }}
      />
      <label className="cbx" for="cbx" onClick={click}>
        <span>
          <svg width="12px" height="10px" viewbox="0 0 12 10">
            <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
          </svg>
        </span>
        <span className="text">
          Я погоджуюсь з{" "}
          <a
            href="http://tascombank.ua/files/Ofitsiini_pravyla_aktsii_“Podarunky“_-konvertyrovan.pdf"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#ffffff",
              textDecoration: "underline",
              fontFamily: "SFProText",
              fontSize: "16px",
              zIndex: 1000,
            }}
          >
            правилами{" "}
          </a>
          акції
        </span>
      </label>
    </>
  )
}

export default CheckBox
